<form #compareForm="ngForm" (ngSubmit)="fetchData(compareForm.value)">
  <div class="pt-12 pb-8 bg-gray-100 m-auto">
    <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="lg:text-center">
        <p
          class="text-base leading-6 text-indigo-600 font-semibold tracking-wide uppercase"
        >
          Compare to get the best rates
        </p>
        <h3
          class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10"
        >
          Find the best way to send money to Africa
        </h3>
        <p class="mt-4 max-w-2xl text-lg leading-7 text-gray-500 lg:mx-auto">
          Use Remitfree today to find the best way to send money from the US to
          Africa. Just fill out the form to get started today!
        </p>
      </div>
    </div>
  </div>

  <div class="flex justify-center items-end flex-shrink">
    <!-- Div Containing select  -->
    <div class="w-64 mx-20 my-10">
      <label for="price" class="block text-sm leading-5 text-gray-700"
        >Price</label
      >
      <div class="mt-1 relative rounded-md h-10">
        <span
          class="text-gray-500 sm:text-sm sm:leading-5 absolute h-full inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
        >
          $
        </span>
        <input
          id="price"
          ngModel
          #amount="ngModel"
          name="amount"
          class="form-input block w-full pl-12 pr-12 sm:text-sm sm:leading-5 h-10 rounded focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 shadow-md"
          placeholder="0.00"
          type="number"
          required
        />
        <span
          class="absolute inset-y-0 right-0 flex items-center h-full py-0 pl-2 pr-3 text-gray-500 m:text-sm sm:leading-5 text-sm"
        >
          USD
        </span>
      </div>
    </div>
    <!-- Div containing Price -->
    <div class="text-left object-center w-64 mx-20 my-10">
      <div class="object-center">
        <span class="rounded-md shadow-sm">
          <button
            type="button"
            class="inline-flex justify-center rounded-md border border-gray-300 px-2 py-2 bg-white text-sm leading-5 font-sm text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 shadow-md"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded="true"
            (click)="hideDropDown()"
          >
            <span
              *ngIf="!selectedCountry"
              class="flex items-center space-x-3 px-4"
            >
              Select a country
            </span>
            <div
              *ngIf="selectedCountry"
              class="flex items-center space-x-3 px-4"
            >
              <img
                [src]="selectedCountry.flag"
                alt=""
                class="flex-shrink-0 h-6 w-6 rounded-full border-solid"
              />
              <span class="block px-4 text-sm leading-5 text-gray-700">
                {{ selectedCountry.name }}
              </span>
            </div>

            <svg
              class="-mr-1 ml-2 h-6 w-6"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </span>
      </div>
      <div
        class="origin-top-right absolute mt-2 min-w-56 mx-60 rounded-md shadow-lg object-center overflow-auto h-64"
        [ngClass]="{ hidden: !dropDown }"
      >
        <div class="rounded-md bg-white shadow-xs">
          <div
            class="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <div
              class="flex items-center space-x-3 px-4 py-2 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              *ngFor="let country of countryList"
              (click)="select(country)"
            >
              <img
                [src]="country.flag"
                alt=""
                class="flex-shrink-0 h-6 w-6 rounded-full"
              />
              <span class="block px-4 py-2 text-sm leading-5 text-gray-700">
                {{ country.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pt-2 pb-2 bg-gray-100 m-auto">
    <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="lg:text-center">
        <p
          class="text-base leading-6 text-indigo-600 font-semibold tracking-wide uppercase"
        >
          Make a selection
        </p>
      </div>

      <div class="flex justify-center items-center flex-shrink mt-5">
        <div class="block mx-20">
          <span class="text-gray-700">Radio Buttons</span>
          <div class="mt-2">
            <div>
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio text-indigo-600"
                  ngModel
                  #pay="ngModel"
                  name="pay"
                  value="debit"
                  checked
                  required
                />
                <span class="ml-2">Debit</span>
              </label>
            </div>
            <div>
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  name="pay"
                  value="credit"
                  ngModel
                  #pay="ngModel"
                  name="pay"
                  required
                />
                <span class="ml-2">Credit</span>
              </label>
            </div>
            <div>
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  name="pay"
                  value="ach"
                  ngModel
                  #pay="ngModel"
                  name="pay"
                  required
                />
                <span class="ml-2">Bank Account</span>
              </label>
            </div>
          </div>
        </div>

        <div class="block mx-20">
          <span class="text-gray-700 uppercase text-sm">Payment method</span>
          <div class="mt-2">
            <div>
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio text-indigo-600"
                  name="receipt"
                  value="mobile"
                  checked
                  ngModel
                  #receipt="ngModel"
                  required
                />
                <span class="ml-2">Mobile Wallet</span>
              </label>
            </div>
            <div>
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  name="receipt"
                  value="pickup"
                  ngModel
                  #receipt="ngModel"
                  required
                />
                <span class="ml-2">Cash Pickup </span>
              </label>
            </div>
            <div>
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  name="receipt"
                  value="deposit"
                  ngModel
                  #receipt="ngModel"
                  required
                />
                <span class="ml-2">Bank Deposit</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w-40 mx-auto px-4 sm:px-6 lg:px-8 mt-5 mb-5">
    <button
      type="submit"
      [disabled]="compareForm.invalid || !selectedCountry"
      [ngClass]="{
        'opacity-25': compareForm.invalid || !selectedCountry
      }"
      class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out"
    >
      Calculate
      <svg
        class="ml-2 -mr-1 h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
        *ngIf="!(compareForm.invalid || !selectedCountry)"
      >
        <path
          fill-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</form>

<div class="flex flex-col w-3/4 mx-auto" *ngIf="responseData">
  <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
    <div
      class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
    >
      <table class="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th
              class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
            >
              Provider
            </th>
            <th
              class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
            >
              Send
            </th>
            <th
              class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
            >
              Receive
            </th>
            <th
              class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
            >
              Speed
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of responseData">
            <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
              <div class="flex items-center">
                <div class="ml-4">
                  <div class="text-sm leading-5 font-medium text-gray-900">
                    {{ item.name }}
                  </div>
                  <div class="text-sm leading-5 text-gray-500">
                    {{ item.url.replace("https://", "") }}
                  </div>
                </div>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
              <span
                class="px-2 inline-flex text-sm leading-5 font-semibold text-green-800"
              >
                ${{ input }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
              <div class="text-sm leading-5 text-gray-900">
                {{ getAmount(item.exrate, input, item.fee) }}
              </div>
              <div class="text-sm leading-5 text-gray-500">
                Rate: {{ item.exrate }}, Fee: ${{ item.fee }}
              </div>
            </td>
            <td
              class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
            >
              {{ item.speed }}
            </td>
            <td
              class="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium"
            >
              <a [href]="item.url" class="text-indigo-600 hover:text-indigo-900"
                >View Website
                <i class="fas fa-arrow-right"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
